/* EcoBrow Grønn — global.js */
(function () {
  'use strict';

  /* ---------- countdown to daily Oslo cutoff ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown-cutoff]').forEach(function (el) {
      var rawCutoff = String(el.getAttribute('data-countdown-cutoff') || '19:30').split(':');
      var cutoffHour = parseInt(rawCutoff[0], 10); if (isNaN(cutoffHour)) cutoffHour = 19;
      var cutoffMin = parseInt(rawCutoff[1] || '0', 10) || 0;
      /* units are localized per market by the section that renders this element */
      var units = String(el.getAttribute('data-countdown-units') || 'h|min|sec').split('|');
      var uH = units[0] || 'h';
      var uM = units[1] || 'min';
      var uS = units[2] || 'sec';
      function osloNow() {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' }));
      }
      function tick() {
        var now = osloNow();
        var cutoff = new Date(now);
        cutoff.setHours(cutoffHour, cutoffMin, 0, 0);
        if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
        var diff = Math.max(0, cutoff - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.textContent = h + ' ' + uH + ' ' + String(m).padStart(2, '0') + ' ' + uM + ' ' + String(s).padStart(2, '0') + ' ' + uS;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main] img');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- variant swatches -> price + url + id ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var json = document.querySelector('[data-variants-json]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    function money(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',00');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    }
    form.querySelectorAll('input[name="option-color"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var match = variants.find(function (v) { return v.option1 === radio.value; });
        if (!match) return;
        idInput.value = match.id;
        var now = document.querySelector('[data-price-now]');
        var was = document.querySelector('[data-price-was]');
        if (now) now.textContent = money(match.price);
        if (was && match.compare_at_price) was.textContent = money(match.compare_at_price);
        var label = document.querySelector('[data-selected-color]');
        if (label) label.textContent = radio.value;
      });
    });
  }

  /* ---------- qty ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      wrapper.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        });
      });
    });
  }

  /* ---------- sticky ATC ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px' });
    io.observe(anchor);
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var submit = document.querySelector('[data-product-form] [type="submit"]');
      if (submit) submit.click();
    });
  }

  /* ---------- before / after slider ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-ba]').forEach(function (frame) {
      var range = frame.querySelector('.ba__range');
      var after = frame.querySelector('.ba__after');
      var handle = frame.querySelector('.ba__handle');
      if (!range || !after) return;
      range.addEventListener('input', function () {
        var v = range.value;
        after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        if (handle) handle.style.left = v + '%';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdowns();
    initGallery();
    initVariants();
    initQty();
    initStickyAtc();
    initBeforeAfter();
  });
})();

/* ---------- Funnel one-pager ---------- */
(function () {
  'use strict';

  function initBundle() {
    /* Tiers are optional: funnel-product now renders a single-unit buy box
       (bundles handled by an external app), explore-pdp still renders tiers. */
    var tiers = document.querySelector('[data-tiers]');
    var cta = document.querySelector('[data-bundle-atc]');
    if (!tiers && !cta) return;
    var stickyLabel = document.querySelector('[data-sticky-cta-label]');
    var errorEl = document.querySelector('[data-atc-error]');
    var mainGroup = document.querySelector('[data-color-main]');
    var pickedOut = document.querySelector('[data-shade-picked]');

    function checkedTier() {
      return tiers ? tiers.querySelector('input[name="fp-tier"]:checked') : null;
    }
    function mainChecked() {
      return mainGroup ? mainGroup.querySelector('input:checked') : null;
    }

    function sync() {
      if (!tiers) return;
      var r = checkedTier();
      tiers.querySelectorAll('[data-tier]').forEach(function (t) {
        t.classList.toggle('is-active', t.contains(r));
      });
      if (r) {
        var label = r.getAttribute('data-cta');
        if (label) {
          if (cta) cta.textContent = label;
          if (stickyLabel) stickyLabel.textContent = label;
        }
      }
    }
    if (tiers) {
      tiers.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'fp-tier') sync();
      });
      sync();
    }

    function syncMainName() {
      var m = mainChecked();
      if (m && pickedOut) pickedOut.textContent = m.getAttribute('data-shade-title') || '';
    }
    function propagateMain() {
      var m = mainChecked();
      if (!m) return;
      document.querySelectorAll('[data-tier-color]').forEach(function (sel) {
        sel.value = m.value;
      });
    }
    var stage = document.querySelector('[data-fp-stage]');
    function jumpToVariantImage() {
      var m = mainChecked();
      if (!m || !stage) return;
      var pos = parseInt(m.getAttribute('data-media-position'), 10);
      if (!pos || pos < 1) return;
      stage.scrollTo({ left: (pos - 1) * stage.clientWidth, behavior: 'smooth' });
    }
    if (mainGroup) {
      mainGroup.addEventListener('change', function () {
        syncMainName();
        propagateMain();
        jumpToVariantImage();
      });
      syncMainName();
      propagateMain();
    }

    function collectItems() {
      var r = checkedTier();
      var qty = r ? parseInt(r.getAttribute('data-qty'), 10) || 1 : 1;
      var single = document.querySelector('[data-single-variant]');
      var map = {};
      if (single) {
        map[single.value] = qty;
      } else if (qty === 1) {
        var m = mainChecked();
        if (!m) return null;
        map[m.value] = 1;
      } else {
        var active = tiers ? tiers.querySelector('[data-tier].is-active') : null;
        var sels = active ? active.querySelectorAll('[data-tier-color]') : [];
        if (!sels.length) {
          var m2 = mainChecked();
          if (!m2) return null;
          map[m2.value] = qty;
        } else {
          sels.forEach(function (sel) {
            map[sel.value] = (map[sel.value] || 0) + 1;
          });
        }
      }
      var funnelUpsell = document.querySelector('[data-funnel-upsell]');
      if (funnelUpsell && funnelUpsell.checked) {
        var upsellId = parseInt(funnelUpsell.getAttribute('data-upsell-variant'), 10);
        if (upsellId) map[upsellId] = (map[upsellId] || 0) + 1;
      }

      return Object.keys(map).map(function (id) {
        return { id: parseInt(id, 10), quantity: map[id] };
      });
    }

    function syncFormVariant() {
      var m = mainChecked();
      document.querySelectorAll('[data-atc-variant-id]').forEach(function (inp) {
        if (m) inp.value = m.value;
      });
    }

    function addToCart(e) {
      if (e && e.preventDefault) e.preventDefault();

      /* With a real /cart/add form on the page (explore buy box), post the form itself.
         Bundle apps (Rapi) change the form's quantity / add hidden fields when a
         2- or 3-pack is picked – posting FormData keeps those, so the right quantity
         is added instead of always 1. */
      var atcFormEl = document.querySelector('[data-bundle-atc-form]');
      var formBody = null;
      if (atcFormEl) {
        syncFormVariant();
        var fd = new FormData(atcFormEl);
        var qtyField = atcFormEl.querySelector('input[name="quantity"]');
        var q = qtyField ? parseInt(qtyField.value, 10) : 1;
        if (!q || q < 1) fd.set('quantity', '1');
        formBody = fd;
      }

      var items = formBody ? null : collectItems();
      if (!formBody && !items) return;

      var goCheckout = cta && cta.getAttribute('data-checkout-url') === 'true';

      if (errorEl) errorEl.hidden = true;
      if (cta) cta.disabled = true;

      /* No theme cart drawer: the add goes through /cart/add.js and the
         installed cart app (Rapid Cart) picks it up from there. */
      fetch('/cart/add.js', formBody
        ? { method: 'POST', headers: { 'Accept': 'application/json' }, body: formBody }
        : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');

          if (goCheckout) {
            window.location.href = '/checkout';
            return null;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          return null;
        })
        .then(function () {
          if (cta) cta.disabled = false;
        })
        .catch(function () {
          if (errorEl) errorEl.hidden = false;
          if (cta) cta.disabled = false;
        });
    }

    var atcForm = document.querySelector('[data-bundle-atc-form]');
    if (atcForm) {
      atcForm.addEventListener('submit', addToCart);
      syncFormVariant();
      if (mainGroup) mainGroup.addEventListener('change', syncFormVariant);
    } else if (cta) {
      cta.addEventListener('click', addToCart);
    }
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);
  }

  function initLesMer() {
    document.querySelectorAll('[data-lesmer]').forEach(function (pEl) {
      var btn = pEl.parentElement.querySelector('[data-lesmer-btn]');
      if (!btn) return;
      pEl.classList.add('is-clamped');
      requestAnimationFrame(function () {
        if (pEl.scrollHeight <= pEl.clientHeight + 2) { btn.hidden = true; pEl.classList.remove('is-clamped'); }
      });
      btn.addEventListener('click', function () {
        var open = !pEl.classList.contains('is-clamped');
        pEl.classList.toggle('is-clamped', open);
        var moreLabel = btn.getAttribute('data-more-label') || 'Read more';
        var lessLabel = btn.getAttribute('data-less-label') || 'Show less';
        btn.textContent = open ? moreLabel : lessLabel;
      });
    });
  }

  function initReviewMore() {
    var btn = document.querySelector('[data-review-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      document.querySelectorAll('.review-wall__card.is-hidden').forEach(function (c) {
        c.classList.remove('is-hidden');
      });
      btn.parentElement.hidden = true;
    });
  }

  function initScrollCarousels() {
    document.querySelectorAll('[data-scroll-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-scroll-track]');
      var prev = carousel.querySelector('[data-scroll-prev]');
      var next = carousel.querySelector('[data-scroll-next]');
      if (!track || !prev || !next) return;

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function update() {
        var max = maxScroll();
        var scrollable = max > 4;
        carousel.classList.toggle('is-scrollable', scrollable);
        prev.disabled = !scrollable || track.scrollLeft <= 4;
        next.disabled = !scrollable || track.scrollLeft >= max - 4;
      }

      function step() {
        var child = track.firstElementChild;
        if (child) {
          var style = window.getComputedStyle(track);
          var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
          var width = child.getBoundingClientRect().width + gap;
          if (width > 40) return width;
        }
        return Math.max(220, track.clientWidth * 0.78);
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', update, { passive: true });
      update();

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(update);
        ro.observe(track);
      }
    });
  }

  function initReviewInteractions() {
    document.querySelectorAll('[data-review-helpful]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.review-wall__helpful');
        if (!wrap || wrap.getAttribute('data-voted') === 'true') return;

        wrap.setAttribute('data-voted', 'true');
        wrap.querySelectorAll('[data-review-helpful]').forEach(function (other) {
          other.disabled = true;
          other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
        });

        var thanks = wrap.querySelector('[data-review-helpful-thanks]');
        if (thanks) thanks.hidden = false;
      });
    });

    var toggle = document.querySelector('[data-review-form-toggle]');
    var panel = document.querySelector('[data-review-form-panel]');
    var closeBtn = document.querySelector('[data-review-form-close]');

    function setReviewForm(open) {
      if (!toggle || !panel) return;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = panel.querySelector('input,select,textarea,button');
        if (first) {
          window.setTimeout(function () { first.focus(); }, 30);
        }
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        setReviewForm(panel.hidden);
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setReviewForm(false);
      });
    }
  }

  function initBurger() {
    var btn = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-market-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.hidden;
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-open', open);
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !menu.contains(e.target) && e.target !== btn) {
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundle();
    initLesMer();
    initReviewMore();
    initScrollCarousels();
    initReviewInteractions();
    initBurger();
  });
})();

/* ---------- v4: swipe gallery + lazy videos ---------- */
(function () {
  'use strict';

  function initFpCarousel() {
    var stage = document.querySelector('[data-fp-stage]');
    if (!stage) return;
    var slides = stage.querySelectorAll('[data-fp-slide]');
    var dots = document.querySelectorAll('[data-fp-dot]');
    var thumbs = document.querySelectorAll('[data-fp-thumb]');
    if (slides.length < 2) return;

    function goTo(i) {
      stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-fp-dot'), 10)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-fp-thumb'), 10)); });
    });

    function setActive(i) {
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var i = Array.prototype.indexOf.call(slides, e.target);
            if (i > -1) setActive(i);
          }
        });
      }, { root: stage, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    } else {
      stage.addEventListener('scroll', function () {
        setActive(Math.round(stage.scrollLeft / stage.clientWidth));
      }, { passive: true });
    }
  }

  function initLazyVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll(
      'video.lazy-video, video.ss-lazy-video'
    ));
    if (!videos.length) return;

    /* Credifence-style behavior:
       1. Poster exists immediately.
       2. MP4 URL stays in data-src initially.
       3. Near viewport: data-src becomes src and video.load() is called.
       4. Native autoplay/muted/playsinline/loop handles normal playback.
       5. If a browser blocks autoplay, a small user-gesture play button appears. */

    if (!document.getElementById('ss-native-video-fallback-style')) {
      var style = document.createElement('style');
      style.id = 'ss-native-video-fallback-style';
      style.textContent =
        '.ss-native-video-shell{position:relative;}' +
        '.ss-native-video-play{' +
          'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);' +
          'z-index:6;width:50px;height:50px;border:0;border-radius:999px;' +
          'display:none;align-items:center;justify-content:center;' +
          'background:rgba(4,4,40,.88);color:#fff;' +
          'box-shadow:0 5px 18px rgba(0,0,0,.18);cursor:pointer;' +
          '-webkit-tap-highlight-color:transparent;' +
        '}' +
        '.ss-native-video-play::before{' +
          'content:"";display:block;margin-left:3px;width:0;height:0;' +
          'border-top:8px solid transparent;border-bottom:8px solid transparent;' +
          'border-left:13px solid currentColor;' +
        '}' +
        '.ss-native-video-play.is-visible{display:flex;}' +
        '.ss-native-video-play:focus-visible{outline:3px solid #fff;outline-offset:3px;}' +
        '@media(max-width:599px){.ss-native-video-play{width:44px;height:44px;}}';
      document.head.appendChild(style);
    }

    function shellFor(video) {
      return video.closest('.feature-videos__media, .video-row__item') || video.parentElement;
    }

    function fallbackButton(video) {
      if (video._ssNativeFallbackButton) return video._ssNativeFallbackButton;

      var shell = shellFor(video);
      if (!shell) return null;
      shell.classList.add('ss-native-video-shell');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ss-native-video-play';
      button.setAttribute('aria-label', 'Play video');

      button.addEventListener('click', function () {
        hydrate(video);
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');

        try {
          var result = video.play();
          if (result && typeof result.then === 'function') {
            result.then(function () {
              hideFallback(video);
            }).catch(function () {
              showFallback(video);
            });
          }
        } catch (e) {
          showFallback(video);
        }
      });

      shell.appendChild(button);
      video._ssNativeFallbackButton = button;
      return button;
    }

    function showFallback(video) {
      var button = fallbackButton(video);
      if (button) button.classList.add('is-visible');
    }

    function hideFallback(video) {
      var button = fallbackButton(video);
      if (button) button.classList.remove('is-visible');
    }

    function hydrate(video) {
      if (video.dataset.ssHydrated === 'true') return;

      var sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) {
        video.dataset.ssHydrated = 'true';
        return;
      }

      sources.forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });

      video.dataset.ssHydrated = 'true';
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');

      try { video.load(); } catch (e) {}
    }

    function isMeaningfullyVisible(video) {
      var rect = video.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.height <= 0 || viewportHeight <= 0) return false;

      var visibleTop = Math.max(0, rect.top);
      var visibleBottom = Math.min(viewportHeight, rect.bottom);
      var visibleHeight = Math.max(0, visibleBottom - visibleTop);

      return (visibleHeight / rect.height) >= 0.25;
    }

    function ensurePlayback(video) {
      if (video.dataset.ssHydrated !== 'true') return;
      if (!isMeaningfullyVisible(video)) return;

      /* Usually unnecessary because the native autoplay attribute starts the
         video after load(). This is only a recovery check for browsers that
         did not immediately honor autoplay after lazy source hydration. */
      window.setTimeout(function () {
        if (!isMeaningfullyVisible(video)) return;

        if (video.paused) {
          try {
            var result = video.play();
            if (result && typeof result.catch === 'function') {
              result.catch(function () {
                showFallback(video);
              });
            }
          } catch (e) {
            showFallback(video);
          }
        }
      }, 300);
    }

    videos.forEach(function (video) {
      video.autoplay = true;
      video.muted = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'none');

      fallbackButton(video);

      video.addEventListener('playing', function () {
        hideFallback(video);
      });

      video.addEventListener('canplay', function () {
        ensurePlayback(video);
      });

      video.addEventListener('error', function () {
        showFallback(video);
      });
    });

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        hydrate(video);
      });
      return;
    }

    /* LOAD observer — this is the key Credifence-style lazy step.
       It loads the source before the video enters the customer's screen. */
    var loadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        hydrate(entry.target);
        loadObserver.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '700px 0px 700px 0px',
      threshold: 0
    });

    /* Playback observer is intentionally lightweight. Native autoplay remains
       the primary mechanism. This observer only pauses far-offscreen videos
       and resumes already-loaded videos when the customer returns. */
    var playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          hydrate(video);

          if (video.paused) {
            try {
              var result = video.play();
              if (result && typeof result.catch === 'function') {
                result.catch(function () {
                  showFallback(video);
                });
              }
            } catch (e) {
              showFallback(video);
            }
          }
        } else if (!entry.isIntersecting) {
          try { video.pause(); } catch (e) {}
        }
      });
    }, {
      root: null,
      threshold: [0, 0.25, 0.5, 0.75]
    });

    videos.forEach(function (video) {
      loadObserver.observe(video);
      playObserver.observe(video);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      videos.forEach(function (video) {
        try { video.pause(); } catch (e) {}
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFpCarousel();
    initLazyVideos();
  });
})();

/* ---------- burger drawer ---------- */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('[data-menu-toggle]');
    var panel = document.querySelector('[data-menu-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-open', open);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
      }
    });
  });
})();
